export default "__VITE_ASSET__6qWjoUF9__$_?url__"